import { render, staticRenderFns } from "./payment-day.vue?vue&type=template&id=0affcf56&scoped=true"
import script from "./payment-day.vue?vue&type=script&lang=js"
export * from "./payment-day.vue?vue&type=script&lang=js"
import style0 from "./payment-day.vue?vue&type=style&index=0&id=0affcf56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0affcf56",
  null
  
)

export default component.exports